import React, { useEffect, useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { useContent } from "../context/ContentContext";

const SIZE_MAP = {
  xs: "0.75em",
  sm: "0.9em",
  base: "1em",
  lg: "1.18em",
  xl: "1.4em",
};

const COLOR_MAP = {
  white: "#FFFFFF",
  gold: "#C5A059",
  muted: "#A3A9B2",
  dim: "rgba(255,255,255,0.6)",
};

const ALIGN_MAP = {
  left: "left",
  center: "center",
  right: "right",
};

/**
 * Renders a text value from site_content (via ContentContext) in the current language.
 * Reads optional style overrides from `${field}_style` in the same section:
 *   { size: "xs|sm|base|lg|xl", color: "white|gold|muted|dim", align: "left|center|right" }
 */
export const CText = ({ section, field, fallback = "", as = "span", className = "", preserveNewlines = false, ...rest }) => {
  const { get } = useContent();
  const { lang, translate } = useLanguage();
  const source = get(section, field, fallback);
  const style = get(section, `${field}_style`, {}) || {};
  const [text, setText] = useState(source);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!source) { setText(""); return; }
    if (lang === "es") { setText(source); return; }
    setLoading(true);
    translate(source, `content:${section}.${field}`).then((r) => {
      if (!cancelled) { setText(r); setLoading(false); }
    });
    return () => { cancelled = true; };
  }, [source, lang, section, field, translate]);

  const Tag = as;
  const inline = {};
  if (preserveNewlines) inline.whiteSpace = "pre-line";
  if (style.size && SIZE_MAP[style.size]) inline.fontSize = SIZE_MAP[style.size];
  if (style.color && COLOR_MAP[style.color]) inline.color = COLOR_MAP[style.color];
  if (style.align && ALIGN_MAP[style.align]) inline.textAlign = ALIGN_MAP[style.align];

  return (
    <Tag className={`${className} ${loading ? "opacity-70" : ""}`} style={inline} {...rest}>
      {text}
    </Tag>
  );
};
